var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 102,
    viewBox: "0 0 98 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2808",
    "data-name": "Grupo 2808",
    transform: "translate(-243 -142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2807",
    "data-name": "Grupo 2807",
    transform: "translate(249 148.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_328",
    "data-name": "Caminho 328",
    d: "M27.77,0V27.12h3V3h52V86.87h-53.5v3h56.5V0Z",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_329",
    "data-name": "Caminho 329",
    d: "M3,48.1,29,28.789,55,48.1V86.87H3ZM0,46.6V89.87H58V46.6L30.162,25.914,29,25.053Z",
    fill: "#d3ff9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_76",
    "data-name": "Elipse 76",
    transform: "translate(271 142)",
    fill: "#1e1e1e",
    stroke: "#e1e1e1",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_78",
    "data-name": "Elipse 78",
    transform: "translate(243 229)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_82",
    "data-name": "Elipse 82",
    transform: "translate(326 229)",
    fill: "#1e1e1e",
    stroke: "#e1e1e1",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_83",
    "data-name": "Elipse 83",
    transform: "translate(298 229)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_80",
    "data-name": "Elipse 80",
    transform: "translate(243 188)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_81",
    "data-name": "Elipse 81",
    transform: "translate(298 188)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_77",
    "data-name": "Elipse 77",
    transform: "translate(326 142)",
    fill: "#1e1e1e",
    stroke: "#e1e1e1",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityIcon);
export default __webpack_public_path__ + "static/media/unityIcon.4dba5662a6b9e0f3ed0703d21a28d924.svg";
export { ForwardRef as ReactComponent };